@if (swConfirmationDeleteOpen) {
    <app-confirmation-delete
        [msg]="msgConfirmationDelete"
        [childConfirmationDelete]="childConfirmationDelete"
        (closed)="onClosedConfirmationDelete($event)"
    ></app-confirmation-delete>
}
@if (swIconListOpen) {
    <app-icon
        [selectedIconId]="selectedIconId()"
        [selectedLabel]="selectedLabelIcon()"
        (closed)="onClosedSelectIcon()"
    ></app-icon>
}
<div class="treelist-page hauteur-100">
    <div
        class="treelist-lock-wrapper"
        [class.treelist-disabled]="menuReorderingService.swEdit()"
    >
        <kendo-treelist
            class="full-height-treelist treelist-fixed-type-column hauteur-88"
            parentIdField="parentId"
            idField="archiveId"
            kendoTreeListExpandable
            id="reordering-treelist"
            [kendoTreeListFlatBinding]="menuService.node()"
            [rowClass]="rowCallback"
            [rowReorderable]="true"
            [(expandedKeys)]="expandedIds"
            (cellClick)="onCellClick($event)"
            (rowReorder)="onRowReorder($event)"
        >
            @if (menuReorderingService.nodeEdit() !== undefined) {
                <ng-template kendoTreeListToolbarTemplate>
                    <!--
                <button
                    kendoTreeListSaveCommand
                    type="button"
                    icon="download"
                    (click)="downloadYaml()"
                >
                    Save
                </button>-->
                    <!-- utiliser formGroup form Angular-->
                    <div class="toolbar">
                        <input
                            #editNameInput
                            kendoTextBox
                            placeholder="Saisir nom de la catégorie..."
                            [ngModel]="menuReorderingService.nodeEdit()?.name ?? ''"
                            (keydown.enter)="menuReorderingService.updateMenuNodeName(editNameInput.value)"
                            (keydown.escape)="menuReorderingService.setSwEditFalse(); this.swIconListOpen = false"
                        />
                        <button
                            kendoButton
                            title="Save"
                            icon="save"
                            (click)="menuReorderingService.updateMenuNodeName(editNameInput.value)"
                        ></button>
                        <button
                            kendoButton
                            title="Cancel"
                            icon="x"
                            (click)="menuReorderingService.setSwEditFalse(); this.swIconListOpen = false"
                        ></button>
                    </div>
                </ng-template>
            }
            <!-- Pas encore codé par Progress Telerik -->
            <!-- En temps voulu changer le label kendoGridRowDragHintTemplate par kendoTreeListRowDragHintTemplate -->
            <kendo-treelist-rowreorder-column [width]="28">
                <ng-template
                    let-dataItem
                    kendoGridRowDragHintTemplate
                >
                    <div class="hint-wrapper">
                        <kendo-svg-icon [icon]="dragIcon"></kendo-svg-icon>
                        @switch (dataItem.type) {
                            @case ('Texte') {
                                <kendo-icon
                                    style="font-size: 24px"
                                    name="file"
                                ></kendo-icon>
                            }
                            @case ('Tableau') {
                                <kendo-icon
                                    style="font-size: 24px"
                                    name="crosstab"
                                ></kendo-icon>
                            }
                            @case ('Figure') {
                                <kendo-icon
                                    style="font-size: 24px"
                                    name="image"
                                ></kendo-icon>
                            }
                            @default {
                                <span>{{ dataItem.name }}</span>
                            }
                        }
                        <!--<span>{{ dataItem.CompanyName }}</span>
                        <div class="separator"></div>
                        <span>{{ dataItem.ContactName }}</span>
                        <div class="separator"></div>
                        <span>{{ dataItem.City }}</span>
                        <div class="separator"></div>
                        <span>{{ dataItem.ContactTitle }}</span>-->
                    </div>
                </ng-template>
            </kendo-treelist-rowreorder-column>
            <kendo-treelist-column
                field="icon"
                title=""
                class="type-icon-cell"
                headerClass="type-icon-header"
                [width]="28"
            >
                <ng-template
                    let-dataItem
                    kendoTreeListCellTemplate
                >
                    @if (dataItem.type === '') {
                        <kendo-icon
                            style="font-size: 24px"
                            [name]="dataItem.icon || 'files-error'"
                            (click)="
                                selectedIconId.set(dataItem.archiveId);
                                selectedLabelIcon.set(dataItem.name ?? '');
                                swIconListOpen = true
                            "
                        ></kendo-icon>
                    }
                </ng-template>
            </kendo-treelist-column>
            @if (swDebug) {
                <kendo-treelist-column
                    field="archiveId"
                    title="ID"
                    [width]="100"
                ></kendo-treelist-column>
            }
            <kendo-treelist-column
                [title]="this.customMessagesService.translate('libelleMenu')"
                [expandable]="true"
            >
                <ng-template
                    let-dataItem
                    kendoTreeListCellTemplate
                >
                    @switch (dataItem.type) {
                        @case ('Texte') {
                            <span>{{ dataItem.bloc | firstLine }}</span>
                        }
                        @case ('Tableau') {
                            <span>Tableau</span>
                        }
                        @case ('Figure') {
                            <span>Image</span>
                        }
                        @default {
                            <span>{{ dataItem.name }}</span>
                        }
                    }
                </ng-template>
            </kendo-treelist-column>
            <!--
            <kendo-treelist-column
                field="name"
                [title]="this.customMessagesService.translate('libelleMenu')"
                [expandable]="true"
            ></kendo-treelist-column>-->
            <kendo-treelist-column
                field="type"
                title=""
                class="type-icon-cell"
                headerClass="type-icon-header"
                [width]="32"
            >
                <ng-template
                    let-dataItem
                    let-isNew="isNew"
                    let-cellContext="cellContext"
                    kendoTreeListCellTemplate
                >
                    @if (dataItem.type === '') {
                        <button
                            title="Add child above"
                            icon="add-row-above"
                            [kendoTreeListAddCommand]="cellContext"
                            (click)="addChild(dataItem.archiveId)"
                        ></button>
                    } @else {
                        <button
                            title="Add above"
                            icon="table-column-insert-left"
                            [kendoTreeListAddCommand]="cellContext"
                            (click)="addChild(dataItem.archiveId)"
                        ></button>
                    }
                </ng-template>
            </kendo-treelist-column>
            <kendo-treelist-column
                field="type"
                title=""
                class="type-icon-cell"
                headerClass="type-icon-header"
                [width]="32"
            >
                <ng-template
                    let-dataItem
                    let-isNew="isNew"
                    let-cellContext="cellContext"
                    kendoTreeListCellTemplate
                >
                    @if (dataItem.type === '') {
                        <button
                            title="Add child below"
                            icon="add-row-below"
                            [kendoTreeListAddCommand]="cellContext"
                            (click)="addChild(dataItem.archiveId)"
                        ></button>
                    } @else {
                        <button
                            title="Add below"
                            icon="table-column-insert-right"
                            [kendoTreeListAddCommand]="cellContext"
                            (click)="addChild(dataItem.archiveId)"
                        ></button>
                    }
                </ng-template>
            </kendo-treelist-column>
            <kendo-treelist-column
                field="type"
                title=""
                class="type-icon-cell"
                headerClass="type-icon-header"
                [width]="32"
            >
                <ng-template
                    let-dataItem
                    let-isNew="isNew"
                    let-cellContext="cellContext"
                    kendoTreeListCellTemplate
                >
                    @if (dataItem.type === '') {
                        <button
                            title="Edit"
                            themeColor="primary"
                            icon="edit-annotations"
                            [kendoTreeListEditCommand]="cellContext"
                            (click)="startEdit(dataItem.archiveId)"
                        ></button>
                    } @else {
                        <button
                            title="Lire"
                            themeColor="primary"
                            icon="arrow-shape"
                            [kendoTreeListEditCommand]="cellContext"
                        ></button>
                    }
                </ng-template>
            </kendo-treelist-column>
            <kendo-treelist-column
                field="type"
                title=""
                class="type-icon-cell"
                headerClass="type-icon-header"
                [width]="32"
            >
                <ng-template
                    let-isNew="isNew"
                    let-dataItem
                    let-cellContext="cellContext"
                    kendoTreeListCellTemplate
                >
                    <button
                        title="Remove"
                        icon="trash"
                        [kendoTreeListRemoveCommand]="cellContext"
                        [disabled]="swConfirmationDeleteOpen"
                        (click)="confirmationDelete(cellContext.viewItem, dataItem.type)"
                    ></button>
                </ng-template>
            </kendo-treelist-column>
            <kendo-treelist-column
                field="type"
                title=""
                class="type-icon-cell"
                headerClass="type-icon-header"
                [width]="24"
            >
                <ng-template
                    let-dataItem
                    kendoTreeListCellTemplate
                >
                    @switch (dataItem.type) {
                        @case ('Texte') {
                            <kendo-icon
                                style="font-size: 24px"
                                name="file"
                            ></kendo-icon>
                        }
                        @case ('Tableau') {
                            <kendo-icon
                                style="font-size: 24px"
                                name="crosstab"
                            ></kendo-icon>
                        }
                        @case ('Figure') {
                            <kendo-icon
                                style="font-size: 24px"
                                name="image"
                            ></kendo-icon>
                        }
                        @default {
                            <span></span>
                        }
                    }
                </ng-template>
            </kendo-treelist-column>
        </kendo-treelist>
    </div>
    <div class="custom-actionbar">
        <div class="treelist-debug">
            Id expansés : {{ expandedIds }}
            <br />
            Id visibles : {{ getVisibleIds() }}
            <br />
            Id sélectionné : {{ selectedRowId }}
        </div>
        <br />
        <p>
            <button
                    (click)="exportPdf()"
                    [disabled]="enCours"
            >
                Fusionner 09.2026
            </button>
            <button
                    (click)="exportPdfAvecUnit()"
                    [disabled]="enCours"
            >
                Fusionner 26.10.2026
            </button>
        </p>
    </div>
</div>
<!--(remove)="removeHandler($event)"-->
<!--(cancel)="cancelHandler($event)"-->
<!--
@if (mode === this.customMessagesService.translate('editMenu')) {
    <kendo-treelist
        kendoTreeListExpandable
        idField="archiveId"
        [data]="rootData | async"
        [fetchChildren]="fetchChildren"
        [hasChildren]="hasChildren"
        [height]="533"
        (add)="addHandler($event)"
        (edit)="editHandler($event)"
        (save)="saveHandler($event)"
    >
        <ng-template kendoTreeListToolbarTemplate>
            <button
                kendoTreeListAddCommand
                type="button"
            >
                Add new
            </button>
        </ng-template>
        <kendo-treelist-column
            field="FirstName"
            title="First Name"
            [expandable]="true"
        >
        </kendo-treelist-column>
        <kendo-treelist-command-column [width]="170">
            <ng-template
                let-isNew="isNew"
                let-cellContext="cellContext"
                kendoTreeListCellTemplate
            >
                <button
                    title="Add Child"
                    [kendoTreeListAddCommand]="cellContext"
                    [svgIcon]="addExpressionIcon"
                ></button>

                <button
                    title="Edit"
                    themeColor="primary"
                    [kendoTreeListEditCommand]="cellContext"
                    [svgIcon]="pencilIcon"
                ></button>

                <button
                    title="Remove"
                    [kendoTreeListRemoveCommand]="cellContext"
                    [svgIcon]="trashIcon"
                ></button>

                <button
                    title="{{ isNew ? 'Add' : 'Update' }}"
                    [kendoTreeListSaveCommand]="cellContext"
                    [disabled]="formGroup?.invalid!"
                    [svgIcon]="saveIcon"
                ></button>

                <button
                    title="{{ isNew ? 'Discard changes' : 'Cancel' }}"
                    [kendoTreeListCancelCommand]="cellContext"
                    [svgIcon]="cancelIcon"
                ></button>
            </ng-template>
        </kendo-treelist-command-column>
    </kendo-treelist>
}
-->
